import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Users, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import TeamModal from "@/components/TeamModal";
import { logout } from "@/store/slices/authSlice";
import type { RootState } from "@/store";
import { supabase } from "@/services/supabase-service";

const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.auth.user);
  const [isTeamModalOpen, setIsTeamModalOpen] = useState(false);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    dispatch(logout());
    navigate("/signin");
  };

  if (!user) return null;

  return (
    <>
      <nav className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex">
              <div className="flex-shrink-0 flex items-center">
                <span className="text-xl font-bold">FileShare</span>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-sm text-gray-500">{user.username}</span>
              <Button variant="ghost" onClick={() => setIsTeamModalOpen(true)}>
                <Users className="h-5 w-5 mr-2" />
                <span className="hidden sm:inline">Team</span>
              </Button>
              <Button variant="ghost" onClick={handleLogout}>
                <LogOut className="h-5 w-5 mr-2" />
                <span className="hidden sm:inline">Logout</span>
              </Button>
            </div>
          </div>
        </div>
      </nav>

      <TeamModal
        isOpen={isTeamModalOpen}
        onClose={() => setIsTeamModalOpen(false)}
      />
    </>
  );
};

export default Navbar;
